var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [!_vm.hideButton ? _c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.open
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("clearance.createRequest")) + " ")]) : _vm._e(), _c('confirm-action-dialog', {
    attrs: {
      "isDialogActive": _vm.isDialogActive,
      "title": _vm.currentStep.title,
      "subtitle": _vm.currentStep.subtitle,
      "supressKeyboardActions": true,
      "loading": _vm.currentStep.loading,
      "rightLoading": _vm.currentStep.loading,
      "rightDisabled": _vm.currentStep.disabled,
      "leftText": _vm.currentStep.backText,
      "rightText": _vm.currentStep.nextText
    },
    on: {
      "update:isDialogActive": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "update:is-dialog-active": function updateIsDialogActive($event) {
        _vm.isDialogActive = $event;
      },
      "leftClick": function leftClick() {
        return _vm.currentStep.back();
      },
      "rightClick": function rightClick() {
        return _vm.currentStep.next();
      }
    }
  }, [_c('v-window', {
    model: {
      value: _vm.stepLocal,
      callback: function callback($$v) {
        _vm.stepLocal = $$v;
      },
      expression: "stepLocal"
    }
  }, [_c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceSteps.CREATE_SHARING
    }
  }, [_vm.isLoading ? _c('div', [_c('v-progress-linear', {
    attrs: {
      "indeterminate": ""
    }
  }), _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', [_vm._v("mdi-magnify")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("clearance.sharing.searchingApprovals")))])], 1)], 1)], 1) : _vm.clearanceApprovals.length ? _c('div', [_vm.clearanceApprovals.find(function (c) {
    return ![_vm.RequestStatusEnum.REPLIED, _vm.RequestStatusEnum.ACCEPTED].includes(c.status);
  }) ? _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "warning"
    }
  }, [_vm._v("mdi-alert")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("clearance.sharing.notAllApprovalsGranted")))])], 1)], 1) : _c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "success"
    }
  }, [_vm._v("mdi-check-circle")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("clearance.sharing.allApprovalsConfirmed")))])], 1)], 1), _vm._l(_vm.clearanceApprovals, function (clearanceApproval) {
    return _c('v-card', {
      key: 'refs-clearance-approval-sharing-dialog' + clearanceApproval.id,
      staticClass: "my-1",
      attrs: {
        "outlined": ""
      },
      on: {
        "click": function click($event) {
          return _vm.setSelectedClearanceApproval(clearanceApproval);
        }
      }
    }, [_c('refs-clearance-approval', {
      attrs: {
        "item": clearanceApproval
      }
    })], 1);
  })], 2) : _c('div', [_c('v-list-item', [_c('v-list-item-icon', [_c('v-icon', {
    attrs: {
      "color": "info"
    }
  }, [_vm._v("mdi-information")])], 1), _c('v-list-item-content', [_c('v-list-item-title', [_vm._v(_vm._s(_vm.$t("clearance.sharing.noApprovalsRequested")))])], 1)], 1)], 1)]), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceSteps.SEND_MAIL
    }
  }, [_vm.stepLocal === _vm.ClearanceSteps.SEND_MAIL ? _c('preselect-template-card', {
    ref: "templateCard",
    staticClass: "mt-1",
    attrs: {
      "templateKey": _vm.PreselectTemplateKeysEnum.REQUEST_CLEARANCE_APPROVAL_MAIL,
      "language": _vm.partner.language,
      "partnerId": _vm.value.partnerId,
      "from": [_vm.partner],
      "context": _vm.context,
      "to": _vm.value.seller ? [_vm.value.seller.email] : [],
      "refs": [{
        refId: this.value.id,
        refType: _vm.ResourceEnum.CLEARANCE
      }],
      "attachmentFileFilters": _vm.attachmentFileFilters
    }
  }) : _vm._e(), _c('v-list-item-action', [_c('v-btn', {
    attrs: {
      "elevation": 0
    },
    on: {
      "click": _vm.copyUrl
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("timeLine.ActivityTimeLineItemShare.btnText")) + " ")])], 1)], 1), _c('v-window-item', {
    attrs: {
      "value": _vm.ClearanceSteps.SUCCESS
    }
  }, [_c('v-img', {
    staticClass: "mt-5 mb-5",
    attrs: {
      "align": "center",
      "justify": "center",
      "contain": "",
      "max-height": "200px",
      "src": require("@/assets/undraw/undraw_add_files_re_v09g.svg")
    }
  })], 1)], 1)], 1), _vm.selectedClearanceApproval ? _c('clearance-approval-side-card', {
    on: {
      "close": function close($event) {
        _vm.selectedClearanceApproval = null;
      }
    },
    model: {
      value: _vm.selectedClearanceApproval,
      callback: function callback($$v) {
        _vm.selectedClearanceApproval = $$v;
      },
      expression: "selectedClearanceApproval"
    }
  }) : _vm._e()], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }